import src from "IMAGE";
export default { src, width: 311, height: 182, blurWidth: 0, blurHeight: 0};
